import { createSelector } from '@reduxjs/toolkit';

import { UniqueNameAllocator } from '@paragon/client-tools';

import { getCommittedComponentDesigns } from './getComponentDesignsSelectors';

export function getUniqueComponentName(requestedName: string, componentDesignNames: readonly string[]): string {
  return new UniqueNameAllocator(componentDesignNames).allocate(requestedName);
}

export const getExistingComponentDesignNames = createSelector(getCommittedComponentDesigns, (componentDesigns) =>
  componentDesigns.map((componentDesign) => componentDesign.component.name),
);

export const createGetUniqueNameForComponentDesign = createSelector(
  getCommittedComponentDesigns,
  (componentDesigns) => {
    return function getUniqueNameForComponentDesign(requestedName: string, componentDesignGuid: string): string {
      const otherComponentDesignNames = componentDesigns
        .filter((componentDesign) => componentDesign.guid !== componentDesignGuid)
        .map((componentDesign) => componentDesign.component.name);

      return getUniqueComponentName(requestedName, otherComponentDesignNames);
    };
  },
);
